import type { ComponentProps, ReactNode } from 'react';
import { Button } from '@/shared/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip';

interface PaginationButtonProps {
  isActive?: boolean;
  isDisabled?: boolean;
  onClick: () => void;
  children: ReactNode;
  tooltip?: string;
  variant?: ComponentProps<typeof Button>['variant'];
  size?: ComponentProps<typeof Button>['size'];
}

export function PaginationButton({
  isActive = false,
  isDisabled = false,
  onClick,
  children,
  tooltip,
  variant,
  size = 'icon',
}: PaginationButtonProps) {
  const resolvedVariant = variant ?? (isActive ? 'default' : 'outline');

  const button = (
    <Button
      variant={resolvedVariant}
      size={size}
      onClick={onClick}
      disabled={isDisabled}
      aria-current={isActive ? 'page' : undefined}
    >
      {children}
    </Button>
  );

  if (tooltip) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{button}</TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    );
  }

  return button;
}
